import nodataImage from '../assets/images/empty.png';
const EmptyResult = ({ title, description, icon, iconSize = 64, className = "" }) => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center py-5">
            {icon ?
                <div className="mb-3">
                    {icon}
                </div>
                : <div className="mb-3">  <img src={nodataImage} height={50} width={50} alt="no data" />
                </div>
            }

            <h5 className="text-muted">{title || "No Data Found"}</h5>

            {description && (
                <p className="text-muted text-center">{description}</p>
            )}
        </div>
    );
};

export default EmptyResult;
